import { Button, Checkbox, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, FormControl, InputLabel, Select, FormHelperText, MenuItem, TextField, Typography } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import React, { useState, useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

export default function AdmissionForm() {
  const currentYear = new Date().getFullYear();
  const academicYear = `${currentYear}-${currentYear + 1}`;
  const [formBlocked, setFormBlocked] = useState(false);
  const [name, setName] = useState('');
  const [dob, setDob] = useState('');
  const [gender, setGender] = useState('');
  const genderOptions = ['Male', 'Female', 'Other'];
  const [religion, setReligion] = useState('');
  const religionOptions = ['Play Group', 'LKG', 'UKG', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII']; 
  const [fatherName, setFatherName] = useState('');
  const [qualification, setQualifi] = useState('');
  const [fatherOccupation, setFatherOccupation] = useState('');
  const fatherOccupationOptions = ['Service', 'Self-employed', 'Business']; 
  const [mobNo, setMobNo] = useState(''); 
  const [reason, setReason] = useState('');
  const [address, setAdd] = useState(''); 
  const [errors, setErrors] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [declarationAccepted, setDeclarationAccepted] = useState(false);
  const [modal, setModal] = useState(''); 

  const handleNameChange = (e) => {
    const value = e.target.value
    setName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      name: value ? '' : 'Please Enter Name'
    }))
  };

  const handleDobChange = (e) => {
    const value = e.target.value;
    setDob(value);

    if (!value) {
      setErrors((prev) => ({
        ...prev, dob: "Please Enter Date Of Birth",
      }));
      setFormBlocked(true);
      return;
    }
  };

  const handleGenderChange = (e) => {
    const value = e.target.value
    setGender(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      gender: value ? '' : 'Please Select Gender'
    }))
  };

  const handleReligionChange = (e) => {
    const value = e.target.value
    setReligion(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      religion: value ? '' : 'Please Select Religion'
    }))
  };

  const handleFatherNameChange = (e) => {
    const value = e.target.value
    setFatherName(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      fatherName: value ? '' : 'Please Enter Father Name'
    }))
  };

  const handleQualifiChange = (e) => {
    const value = e.target.value
    setQualifi(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      qualification: value ? '' : 'Please Enter Qualification'
    }))
  };

  const handleFatherOccupationChange = (e) => {
    const value = e.target.value
    setFatherOccupation(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      fatherOccupation: value ? '' : 'Please Select Occupation'
    }))
  };

  const handleMnoChange = (e) => {
    const value = e.target.value
    setMobNo(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      mobNo: value ? '' : 'Please Enter Mobile No'
    }))
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleAddChange = (e) => {
    setAdd(e.target.value);
  };

  const handleReset = () => {
    setName('');
    setDob('');
    setGender('');
    setReligion('');
    setFatherName('');
    setQualifi('');
    setFatherOccupation('');
    setMobNo('');
  }

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    if (!name || !dob || !gender || !religion || !fatherName || !qualification || !fatherOccupation || !mobNo) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        name: !name ? 'Name is required' : prevErrors.name,
        dob: !dob ? "Date Of Birth is required" : prevErrors.dob,
        gender: !gender ? "Gender is required" : prevErrors.gender,
        religion: !religion ? "Religion is required" : prevErrors.religion,
        fatherName: !fatherName ? "Fatehr Name is required" : prevErrors.fatherName,
        qualification: !qualification ? "Qualification is required" : prevErrors.qualification,
        fatherOccupation: !fatherOccupation ? "Father Occupation is required" : prevErrors.fatherOccupation,
        mobNo: !mobNo ? "Mobile No is required" : prevErrors.mobNo,
      }));
     
      setLoading(false);
      setIsSubmitting(false);
      return;
    }

    setIsSubmitting(true);
    const formData = new FormData();
    formData.append('name', name);
    formData.append('dob', dob);
    formData.append('gender', gender);
    formData.append('religion', religion);
    formData.append('fatherName', fatherName);
    formData.append('qualification', qualification);
    formData.append('fatherOccupation', fatherOccupation);
    formData.append('mobNo', mobNo);
    formData.append('reason', reason);
    formData.append('address', address);

    try {
      const response = await fetch(`/api/AdmissionForm`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const responseData = await response.json();
        toast.success(responseData.message)
        handleReset();
      } else {
        const responseData = await response.json();
        toast.error(responseData.error)
      }
    } catch (error) {
      console.error('Error uploading data:', error);
    } finally {
      setLoading(false)
    }
    setIsSubmitting(false);
  }

  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <>
      <div className='my-4'>
        <div className='row mx-2'>
          <div className='max-w-3xl mx-auto text-center mb-8' data-aos="fade-down">
            <h2 className='text-2xl sm:text-2xl font-extrabold tracking-wide text-gray-900 mb-3 center'>ADMISSION FORM FOR ACADEMIC YEAR {academicYear}</h2>
            <p className='text-gray-600 text-sm sm:text-base leading-relaxed mb-3' data-aos="fade-up" data-aos-delay="100">If any of the particular given below found incorrect or incomplete,<br />
              the admission form for admission will be rejected</p>
            <p className="font-weight-bold text-center text-uppercase" style={{ fontWeight: '800', textDecoration: 'underline' }} >All fields marked with asterisk (<span className='text-danger'>*</span>)  are mandatory.</p>
          </div>
          <div className='col-12 col-md-6 mb-2' data-aos="fade-up" data-aos-delay="100">
            <TextField label={<span>Full Name of Candidate<span className='text-danger'>*</span></span>} variant="outlined" fullWidth value={name} onChange={handleNameChange} error={!!errors.name} helperText={errors.name} disabled={!!formBlocked} />
          </div>
          <div className='col-6 mb-2' data-aos="fade-up" data-aos-delay="200">
            <TextField label={<span>Date of Birth<span className='text-danger'>*</span></span>} variant="outlined" type="date" fullWidth value={dob} onChange={handleDobChange} error={!!errors.dob} helperText={errors.dob} InputLabelProps={{ shrink: true }} />
          </div>
          <div className='col-6 mb-2' data-aos="fade-up" data-aos-delay="300">
            <FormControl variant="outlined" fullWidth error={!!errors.gender} disabled={!!formBlocked}>
              <InputLabel id="demo-simple-select-label">Gender<span className='text-danger'>*</span></InputLabel>
              <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Gender" value={gender} onChange={handleGenderChange}>
                {genderOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>{option}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.gender}</FormHelperText>
            </FormControl>
          </div>
          <div className='col-6 mb-2' data-aos="fade-up" data-aos-delay="350">
            <FormControl variant="outlined" fullWidth error={!!errors.religion} disabled={!!formBlocked}>
              <InputLabel id="demo-simple-select-label">CLass<span className='text-danger'>*</span></InputLabel>
              <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Religion" value={religion} onChange={handleReligionChange}>
                {religionOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>{option}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.religion}</FormHelperText>
            </FormControl>
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="500">
            <TextField label={<span>Father's Name<span className='text-danger'>*</span></span>} variant="outlined" fullWidth value={fatherName} onChange={handleFatherNameChange} error={!!errors.fatherName} helperText={errors.fatherName} disabled={!!formBlocked} />
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="550">
            <TextField label={<span>Qualification<span className='text-danger'>*</span></span>} variant="outlined" fullWidth value={qualification} onChange={handleQualifiChange} error={!!errors.qualification} helperText={errors.qualification} disabled={!!formBlocked} />
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="600">
            <FormControl variant="outlined" fullWidth error={!!errors.fatherOccupation} disabled={!!formBlocked}>
              <InputLabel id="demo-simple-select-label">Occupation<span className='text-danger'>*</span></InputLabel>
              <Select labelId="demo-simple-select-label" id="demo-simple-select" label="Occupation" value={fatherOccupation} onChange={handleFatherOccupationChange}>
                {fatherOccupationOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>{option}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.fatherOccupation}</FormHelperText>
            </FormControl>
          </div>
          <div className='col-6 col-md-3 mb-2' data-aos="fade-up" data-aos-delay="800">
            <TextField label={<span>Mobile No<span className='text-danger'>*</span></span>} variant="outlined" type="number" fullWidth value={mobNo} onChange={handleMnoChange} error={!!errors.mobNo} helperText={errors.mobNo} disabled={!!formBlocked} />
          </div> 
          <div className="col-12 my-2" data-aos="fade-up" data-aos-delay="100">
            <TextField id="filled-multiline-flexible" label="Reason For Seeking Admission In This School" multiline maxRows={10} variant="outlined" fullWidth value={reason} onChange={handleReasonChange} disabled={!!formBlocked} />
          </div>
          <div className="col-12 my-2" data-aos="fade-up" data-aos-delay="1050">
            <TextField id="filled-multiline-flexible" label="Address" multiline maxRows={10} variant="outlined" fullWidth value={address} onChange={handleAddChange} disabled={!!formBlocked} />
          </div> 
          <div className="col-12 mt-3">
            <FormControlLabel
              control={
                <Checkbox
                  checked={declarationAccepted}
                  onChange={(e) => setDeclarationAccepted(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2">
                  I hereby declare that all the information provided in this admission form is true and correct to the best of my knowledge.
                  I understand that if any information is found false, the school may reject/cancel the admission.
                </Typography>
              }
            />
          </div>
        </div>
        <div className='d-flex justify-content-center' data-aos="fade-up" data-aos-delay="1100">
          <Button variant='contained' color='error' onClick={handleSubmit} disabled={formBlocked || !declarationAccepted}>Submit</Button>
        </div>
        <Dialog open={modal} onClose={() => setModal('')} fullWidth maxWidth="sm">
          <DialogTitle sx={{ fontWeight: 600 }}>
            🎉 Admission Form Submitted Successfully
          </DialogTitle>

          <DialogContent>

            <div className="bg-green-50 border border-green-600 text-green-800 p-4 rounded-md text-center mb-4">
              <p className="text-sm">Your Application Reference Number</p>
              <h2 className="text-2xl font-bold tracking-widest mt-1">
                {modal}
              </h2>
            </div>

            <p className="text-sm mb-2">
              Please save this <strong>Reference Number</strong> carefully. It will be required to check your child's admission status in the future.
            </p>

            <p className="text-sm mb-2">
              Along with this Reference Number, you will also need to enter the <strong>Student's Date of Birth</strong> to track the application.
            </p>

            <p className="text-sm text-gray-600">
              We recommend taking a screenshot or writing it down for safe keeping.
            </p>

          </DialogContent>

          <DialogActions sx={{ p: 2 }}>
            <Button variant="contained" color="primary" onClick={() => setModal('')}>
              OK, I have saved it
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      {loading && (
        <div className="modal-backdrop show"></div>
      )}
      <div className={`modal fade ${loading ? 'show' : ''}`} style={{ display: loading ? 'block' : 'none' }} tabIndex="-1" role="dialog">
        <div id="preloader">
          <div className="bar-container">
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
            <div className="bar"></div>
          </div>
          <h1>Loading...</h1>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}
